import Payments from '@/components/payments/Payments'
import PaymentsList from '@/components/payments/PaymentsList'

export default [
  {
    path: '/payments',
    component: Payments,
    children: [
      {path: '', component: PaymentsList}
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/payments/routes.js